const PortfolioData = {
  PortfolioItems: [
    {
      id: 1,
      imgUrl: '1',
      title: 'Rifa lottery HTML template',
      client: 'Pixner',
      link: 'https://www.themeforest.com/'
    },
    {
      id: 2,
      imgUrl: '2',
      title: 'Rifa lottery HTML template',
      client: 'Pixner',
      link: 'https://www.themeforest.net'
    },
    {
      id: 3,
      imgUrl: '3',
      title: 'Rifa lottery HTML template',
      client: 'Pixner',
      link: 'https://www.themeforest.net'
    },
    {
      id: 4,
      imgUrl: '1',
      title: 'Rifa lottery HTML template',
      client: 'Pixner',
      link: 'https://www.themeforest.net'
    },
    {
      id: 5,
      imgUrl: '1',
      title: 'Rifa lottery HTML template',
      client: 'Pixner',
      link: 'https://www.themeforest.net'
    }
  ]
}

export default PortfolioData